import React from 'react';
import Plot from 'react-plotly.js';

const ChargeDischargePlot = () => {
  // Data generation - create separate arrays for each capacity
  const mAh_70 = Array.from({ length: 70 }, (_, i) => (i * 3500) / 69);   // 70% capacity - ends at 3500 mAh
  const mAh_90 = Array.from({ length: 90 }, (_, i) => (i * 4500) / 89);   // 90% capacity - ends at 4500 mAh  
  const mAh_100 = Array.from({ length: 100 }, (_, i) => (i * 5000) / 99); // 100% capacity - ends at 5000 mAh

  // Charge curves - realistic battery charging curve: steep rise then flatten
  const charge_70 = mAh_70.map(x => 2.5 + 1.6 * (1 - Math.exp(-x/600)));     // 70% - ends at 3500 mAh
  const charge_this = mAh_90.map(x => 2.5 + 1.6 * (1 - Math.exp(-x/700)));   // 90% This Cell - ends at 4500 mAh  
  const charge_new = mAh_100.map(x => 2.5 + 1.6 * (1 - Math.exp(-x/800)));   // 100% New Cell - ends at 5000 mAh

  // Discharge curves - realistic battery discharging curve: flat start then steep drop
  const discharge_70 = mAh_70.map(x => 4.1 - 1.6 * Math.pow(x/3500, 2.5));         // 70% - ends at 3500 mAh
  const discharge_this = mAh_90.map(x => 4.1 - 1.6 * Math.pow(x/4500, 2.5));      // 90% This Cell - ends at 4500 mAh
  const discharge_new = mAh_100.map(x => 4.1 - 1.6 * Math.pow(x/5000, 2.5));      // 100% New Cell - ends at 5000 mAh

  const data = [
    // Charge curves
    {
      x: mAh_70,
      y: charge_70,
      type: 'scatter',
      mode: 'lines',
      name: 'Charge 70%',
      line: { color: 'deepskyblue' }
    },
    {
      x: mAh_90,
      y: charge_this,
      type: 'scatter',
      mode: 'lines',
      name: 'Charge 90% (This Cell)',
      line: { color: 'orangered' }
    },
    {
      x: mAh_100,
      y: charge_new,
      type: 'scatter',
      mode: 'lines',
      name: 'Charge 100% (New Cell)',
      line: { color: 'lime' }
    },
    // Discharge curves
    {
      x: mAh_70,
      y: discharge_70,
      type: 'scatter',
      mode: 'lines',
      name: 'Discharge 70%',
      line: { color: 'deepskyblue', dash: 'dash' }
    },
    {
      x: mAh_90,
      y: discharge_this,
      type: 'scatter',
      mode: 'lines',
      name: 'Discharge 90% (This Cell)',
      line: { color: 'orangered', dash: 'dash' }
    },
    {
      x: mAh_100,
      y: discharge_new,
      type: 'scatter',
      mode: 'lines',
      name: 'Discharge 100% (New Cell)',
      line: { color: 'lime', dash: 'dash' }
    },
    // End point markers with annotations
    {
      x: [3500, 4500, 5000],
      y: [charge_70[charge_70.length - 1], charge_this[charge_this.length - 1], charge_new[charge_new.length - 1]],
      type: 'scatter',
      mode: 'markers+text',
      marker: { color: ['deepskyblue', 'orangered', 'lime'], size: 10 },
      text: ['70%', 'This Cell<br>90%', 'New Cell<br>100%'],
      textposition: 'top center',
      showlegend: false
    },
    {
      x: [3500, 4500, 5000],
      y: [discharge_70[discharge_70.length - 1], discharge_this[discharge_this.length - 1], discharge_new[discharge_new.length - 1]],
      type: 'scatter',
      mode: 'markers',
      marker: { color: ['deepskyblue', 'orangered', 'lime'], size: 8 },
      showlegend: false
    }
  ];

  const layout = {
    title: {
      text: 'Charge/Discharge Curves for Different Cell States',
      font: { color: 'white' }
    },
    xaxis: {
      title: 'mAh',
      range: [0, 5200],
      color: 'white',
      gridcolor: 'gray'
    },
    yaxis: {
      title: 'V',
      range: [2, 4.5],
      color: 'white',
      gridcolor: 'gray'
    },
    legend: {
      font: { color: 'white' }
    },
    plot_bgcolor: 'black',
    paper_bgcolor: 'black',
    font: { color: 'white' },
    hovermode: 'x unified',
    annotations: [
      {
        x: 500,
        y: 3.8,
        text: "Charge",
        showarrow: false,
        font: { size: 14, color: 'white' },
        bgcolor: "rgba(255,255,255,0.1)"
      },
      {
        x: 500,
        y: 3.0,
        text: "Discharge",
        showarrow: false,
        font: { size: 14, color: 'white' },
        bgcolor: "rgba(255,255,255,0.1)"
      }
    ]
  };

  const config = {
    displayModeBar: true,
    displaylogo: false,
    modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d']
  };

  return (
    <div style={{ width: '100%', height: '500px' }}>
      <Plot
        data={data}
        layout={layout}
        config={config}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default ChargeDischargePlot;
